import { buildResult, skip } from "../../buildResult";
import { defineTest } from "../../defineTest";
import { AUDIO_INGEST_LAMBDAS, getLambdaEvents, resolveTrace } from "../../helper/trace";

export default defineTest(
  "trace_audio_ingest_start_end",
  "Audio ingest START/END",
  ({ trace, fetchErrors }) => {
    const resolved = resolveTrace({ trace, fetchErrors });
    if (!resolved.ok) return resolved.result;

    const { events } = resolved;
    if (events.length === 0) return skip("Trace has no events");

    const warnings = [];
    const successes = [];

    for (const lambdaName of AUDIO_INGEST_LAMBDAS) {
      const lambdaEvents = getLambdaEvents(events, lambdaName);
      if (lambdaEvents.length === 0) continue;

      const starts = lambdaEvents.filter((e) => e.status === "START").length;
      const ends = lambdaEvents.filter((e) => e.status === "END").length;

      if (starts > 0 && ends === 0) {
        warnings.push(`${lambdaName} has START but no END`);
      } else if (starts > 0 && ends > 0) {
        successes.push(`${lambdaName}: START and END present`);
      } else if (ends > 0 && starts === 0) {
        warnings.push(`${lambdaName} has END without START in trace`);
      }
    }

    if (warnings.length === 0 && successes.length === 0) {
      return skip(`No ${AUDIO_INGEST_LAMBDAS.join(" or ")} events in trace`);
    }

    return buildResult({ warnings, successes });
  }
);
